import { useState } from 'react';
import { faSquarePollVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonWithTooltip,
  insertDirective$,
  usePublisher,
} from '@mdxeditor/editor';
import { useTranslation } from 'react-i18next';

import type { IPollMdxDirectiveDialogFormValues } from './PollMdxDirectiveDialogForm';
import { POLL_MDX_DIRECTIVE_NAME } from './pollMdxDirectiveConstants';
import { PollMdxDirectiveDialogForm } from './PollMdxDirectiveDialogForm';

export type IPollMdxDirectiveToolbarButtonProps = {
  appId: string;
};

export type IPollMdxDirectiveAttributes = {
  appId: string;
  pollId: string;
};

export const PollMdxDirectiveToolbarButton: React.FC<
  IPollMdxDirectiveToolbarButtonProps
> = (props) => {
  const { appId } = props;
  const insertDirective = usePublisher(insertDirective$);
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = (values: IPollMdxDirectiveDialogFormValues): void => {
    setOpened(false);
    const attributes: IPollMdxDirectiveAttributes = {
      appId,
      pollId: values.pollId ?? '',
    };

    insertDirective({
      name: POLL_MDX_DIRECTIVE_NAME,
      type: 'leafDirective',
      attributes,
    });
  };

  return (
    <>
      <PollMdxDirectiveDialogForm
        appId={appId}
        opened={opened}
        onClose={() => setOpened(false)}
        onSubmit={handleSubmit}
      />

      <ButtonWithTooltip
        title={t('PollMdxDirectiveToolbarButton.tooltip')}
        onClick={() => setOpened(true)}
      >
        <FontAwesomeIcon
          icon={faSquarePollVertical}
          fontSize={18}
          style={{ padding: 3 }}
        />
      </ButtonWithTooltip>
    </>
  );
};
